<template>
  <div v-if="datetime" class="ml-4 pl-2 pb-4">
    <span class="greyDarken1--text">
      {{
      momentTz
      .tz(datetime, timezone)
      .clone()
      .tz(momentTz.tz.guess(true))
      .format('YYYY-MM-DD HH:mm:ss z')
      }}
    </span>
  </div>
</template>

<script>
export default {
  name: "ShowLocalTime",
  props: ["datetime", "timezone"]
};
</script>

<style></style>
